export enum VerificationStatusEnum {
  DataEntry = 1,
  DataEntered = 2,
  Verified = 3,
  HasUnverifiedChanges = 4
}

export const VerificationStatusOptions = [
{ id: 1, label: 'Data Entry' },
{ id: 2, label: 'Data Entry Complete' },
{ id: 3, label: 'Verified' },
{ id: 4, label: 'Has Unverified Changes' }
];
